import CreditRewardDisplay from './CreditRewardDisplay'
export default CreditRewardDisplay